<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="submit" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isVisible" :vm-title="$t('strings.assign_to')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="projects" :label='$t("suppliers_dashboard.project")' disable-match :danger="$v.form.project_id.$invalid && $v.form.project_id.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers_dashboard.project_id') })" :serializer="item => item.name" required :data="catalog.projects" :placeholder='$t("suppliers_dashboard.project_placeholder")' v-model="form.project_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers_dashboard.amount_placeholder")' :danger="$v.form.amount.$invalid && $v.form.amount.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers_dashboard.amount') })" v-model="form.amount" :label='$t("suppliers_dashboard.amount")' type="currency")
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
const { mapGetters, mapActions } = createNamespacedHelpers('Suppliers')

export default {
  name: 'ModalAssignTo',
  mixins: [ModalMixin1],
  props: {
    supplierId: {
      default: null,
      type: Number
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  validations () {
    return {
      form: {
        project_id: {
          required
        },
        amount: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['catalog'])
  },
  methods: {
    ...mapActions([
      'assignDeposit',
      'loadCatalog'
    ]),
    close () {
      this.$emit('closeModal')
    },
    async submit () {
      await this.assignDeposit({ id: this.supplierId, ...this.form })
      this.$emit('updateRecords', this.form, this.isAdd)
      await this.close()
    }
  }
}
</script>
<style lang="scss">
.image_section {
  padding-left: 0.5rem;
  -webkit-box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
  box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
}
.image_indicator {
  margin: 1rem 0 0 76%;
  text-align: center;
  padding: .4rem;
  width: 2rem;
  height: 2rem;
  border-top: 1px solid rgba(var(--primary),1);
  border-right: 1px solid rgba(var(--primary),1);
  border-bottom: 1px solid rgba(var(--primary),1);
  border-left: 1px solid rgba(var(--primary),1);
  border-radius: 100%;
}
.images_container {
  padding-left: 1.3rem;
}
</style>
